function loading() {
  document.body.classList.add('is-loaded');
}

let popupOpened = false;

function openPopupOnce() {
  if (popupOpened) return;
  popupOpened = true;

  window.postscript?.popups.open("893f387f-1225-41fa-9ac2-869f378d2a44", {
    activePopupBehavior: 'ALWAYS_DISMISS',
    respectPopupStatus: true
  });

  ['mousemove', 'touchstart', 'keydown'].forEach(type => {
    window.removeEventListener(type, openPopupOnce);
  });
}

['mousemove', 'touchstart', 'keydown'].forEach(type => {
  window.addEventListener(type, openPopupOnce);
});

export {loading};
